import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3 max-w-[280px]" }

import { computed } from "vue";
import { ProjectListed } from "@/apps/page/project/sidebar/sections/tool/project-listed.interface";
import ProjectCard from "@/apps/page/project/sidebar/sections/ProjectCard.vue";
import ToolProjectSection from "@/views/page/ToolProjectSection.vue";
import { PageSection } from "@/apps/page/page.interfaces";
import { useSections } from "@/apps/page/services/useSections";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddTool',
  props: {
    project: {},
    fontFamily: {},
    styleValues: {}
  },
  setup(__props: any) {

const props = __props;

const { getSectionTypeByTool } = useSections();

const isScriptProject = ["cookie", "coffee", "ticker"].includes(props.project.tool);
const icon = computed(() => getSectionTypeByTool(props.project.tool)?.icon);

const preview = {
    width: isScriptProject ? 660 : 1540,
    height: isScriptProject ? "300px" : "auto",
    zoom: isScriptProject ? 0.41 : 0.175,
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProjectCard, {
      name: _ctx.project.name,
      subtitle: '/' + _ctx.project.uuid,
      icon: icon.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "relative overflow-hidden",
          style: _normalizeStyle({ zoom: preview.zoom, width: preview.width + 'px', height: preview.height })
        }, [
          _createVNode(ToolProjectSection, {
            type: _ctx.project.tool,
            uuid: _ctx.project.uuid,
            fontFamily: _ctx.fontFamily,
            styleValues: _ctx.styleValues,
            isProjectPublished: _ctx.project.access === 'published',
            isListOfItemsToPick: ""
          }, null, 8, ["type", "uuid", "fontFamily", "styleValues", "isProjectPublished"])
        ], 4)
      ]),
      _: 1
    }, 8, ["name", "subtitle", "icon"])
  ]))
}
}

})